<template>
  <div class="template">
    <ContactDesktop class="template__Desktop" />
    <ContactMobile class="template__Mobile" />
  </div>
</template>

<script>
import ContactDesktop from '@/components/contact/ContactDesktop.vue'
import ContactMobile from '@/components/contact/ContactMobile.vue'
export default {
  name: 'ContactView',
  components: {
    ContactDesktop,
    ContactMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>
